module.exports = __webpack_public_path__ + "static/media/no.bf5d695c.png";